import { LIMITS, STAT_BUDGET } from "../constants/gameConstants.js";
import type { VehicleBlueprint } from "../types/VehicleBlueprint.js";

export interface StatBudgetReport {
  total: number;
  budget: number;
  withinBudget: boolean;
  breakdown: Record<string, number>;
}

const baseline = (range: { min: number; max: number }) => range.min;

export function computeStatBudget(bp: VehicleBlueprint): StatBudgetReport {
  const w = STAT_BUDGET.weights;
  const breakdown: Record<string, number> = {};

  breakdown.maxSpeed = (bp.handling.maxSpeed - baseline(LIMITS.handling.maxSpeed)) * w.maxSpeed;
  breakdown.acceleration =
    (bp.handling.acceleration - baseline(LIMITS.handling.acceleration)) * w.acceleration;
  breakdown.braking = (bp.handling.braking - baseline(LIMITS.handling.braking)) * w.braking;
  breakdown.turnRate = (bp.handling.turnRate - baseline(LIMITS.handling.turnRate)) * w.turnRate;
  breakdown.traction = (bp.handling.traction - baseline(LIMITS.handling.traction)) * w.traction;
  breakdown.drift = (bp.handling.drift - baseline(LIMITS.handling.drift)) * w.drift;
  breakdown.damage = (bp.weapon.damage - baseline(LIMITS.weapon.damage)) * w.damage;
  breakdown.reload =
    (1 / bp.weapon.reloadMs - 1 / LIMITS.weapon.reloadMs.max) * w.reload;
  breakdown.projectileSpeed =
    (bp.weapon.projectileSpeed - baseline(LIMITS.weapon.projectileSpeed)) * w.projectileSpeed;
  breakdown.range = (bp.weapon.range - baseline(LIMITS.weapon.range)) * w.range;
  breakdown.projectileLifetimeMs =
    (bp.weapon.projectileLifetimeMs - baseline(LIMITS.weapon.projectileLifetimeMs)) * w.projectileLifetimeMs;
  breakdown.maxBounces = (bp.weapon.maxBounces ?? 0) * w.maxBounces;
  breakdown.maxHealth = (bp.stats.maxHealth - baseline(LIMITS.stats.maxHealth)) * w.maxHealth;
  breakdown.armour = (bp.stats.armour - baseline(LIMITS.stats.armour)) * w.armour;
  breakdown.mass = (bp.stats.mass - baseline(LIMITS.stats.mass)) * w.mass;

  let total = 0;
  for (const key of Object.keys(breakdown)) {
    breakdown[key] = round1(breakdown[key]);
    total += breakdown[key];
  }
  total = round1(total);

  return {
    total,
    budget: STAT_BUDGET.total,
    withinBudget: total <= STAT_BUDGET.total,
    breakdown,
  };
}

function round1(n: number): number {
  return Math.round(n * 10) / 10;
}
